
class OperationsHelper {

    delay (func, time) {
        setTimeout(func, time);
    }
}

export default new OperationsHelper();
